import { Box, Stack } from '@mui/material';
import React from 'react';

import {
  BackgroundBrandingRootStyles,
  BRANDING_ITEMS,
  getBackgroundBrandingSideStyles,
  getBrandingItemStyles,
} from './BackgroundBranding.styles.ts';

const leftBrandingItems = BRANDING_ITEMS.filter((item) => item.side === 'left');
const rightBrandingItems = BRANDING_ITEMS.filter((item) => item.side === 'right');

export const BackgroundBranding: React.FC = () => {
  return (
    <Stack sx={BackgroundBrandingRootStyles}>
      <Box sx={getBackgroundBrandingSideStyles('left')}>
        {leftBrandingItems.map((item, index) => (
          <Box
            key={`left-${item.top}-${index}`}
            sx={getBrandingItemStyles(item)}
          />
        ))}
      </Box>
      <Box sx={getBackgroundBrandingSideStyles('right')}>
        {rightBrandingItems.map((item, index) => (
          <Box
            key={`right-${item.top}-${index}`}
            sx={getBrandingItemStyles(item)}
          />
        ))}
      </Box>
    </Stack>
  );
};
